var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "21px",
    viewBox: "0 0 21 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape Copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Menu",
    transform: "translate(-1629.000000, -63.000000)",
    fill: "#000000",
    fillRule: "nonzero",
    stroke: "#000000",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1648.83566,82.0310421 L1644.21734,77.4137472 C1645.4562,75.9898004 1646.20625,74.131929 1646.20625,72.1013304 C1646.20625,67.6314856 1642.56975,64 1638.10313,64 C1633.63229,64 1630,67.6356984 1630,72.1013304 C1630,76.5669623 1633.6365,80.2026608 1638.10313,80.2026608 C1640.13418,80.2026608 1641.99246,79.4527716 1643.41672,78.2141907 L1648.03504,82.8314856 C1648.1446,82.94102 1648.29208,83 1648.43535,83 C1648.57862,83 1648.7261,82.9452328 1648.83566,82.8314856 C1649.05478,82.6124169 1649.05478,82.2501109 1648.83566,82.0310421 Z M1631.13351,72.1013304 C1631.13351,68.2592018 1634.26015,65.1374723 1638.09891,65.1374723 C1641.94189,65.1374723 1645.06432,68.2634146 1645.06432,72.1013304 C1645.06432,75.9392461 1641.94189,79.0694013 1638.09891,79.0694013 C1634.26015,79.0694013 1631.13351,75.943459 1631.13351,72.1013304 Z",
    id: "Shape-Copy"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.9d6f1a3e20b8d8527899c2585d7d20d3.svg";
export { ForwardRef as ReactComponent };